/**
 * me service seam - 본인 화면 설정(ENV0010).
 * 언어·컬러테마·글자 크기. null 은 '고르지 않음'이라 그대로 전달한다(언어는 회사 대표 언어, 테마는 시스템 기본을 따른다).
 */
import http from '@/services/http';

const PREFS = '/api/v1/me/prefs';

export const prefRepo = {
  async load() {
    const b = await http.get(PREFS);
    return b?.data || null;
  },
  async save(prefs) {
    const b = await http.post(PREFS, prefs);
    return b?.data;
  },
};
